<template>
  <BaseButton secondary>
    <slot />
  </BaseButton>
</template>

<script setup lang="ts">
import BaseButton from "@/components/buttons/BaseButton.vue";
</script>